import { configureStore } from "@reduxjs/toolkit";
import showGroupsReducer from "./features/dashbord";
import filtersReducer from "./features/filters";
import userReducer from "./features/user";
import reportsSelectedSlice from "./features/reportsSelected";
import errorFetchingActionsReducer from "./features/errorFetchingActions";
import treeViewSelectedChangeReducer, {
  TREE_VIEW_SELECTED_CHANGE,
} from "./features/treeViewChangeSelected";
import flagDetailsBackButtonReducer, {
  FLAG_DETAILS_BACK_ROUTE,
} from "./features/flagDetailsBackButtonRoute";
import defaultTableFiltersReducer, {
  DEFAULT_TABLE_FILTERS,
} from "./features/defaultTableFilters";
import settingsReducer, {
  SETTINGS_REDUCER_KEY,
} from "./features/settings/settingsSlice";
import activityLogReducer, {
  ACTIVITY_LOG_REDUCER_NAME,
} from "./features/activityLog/activityLogSlice";
import rulesPageReducer, {
  RULES_PAGE_REDUCER_NAME,
} from "./features/rules/rulesSlice";
import customReportsReducer, {
  CUSTOM_REPORTS_REDUCER_NAME,
} from "./features/customReport/customReportsSlice";
import monitoringQueueReducer, {
  MONITORING_QUEUE_REDUCER_NAME,
} from "./features/monitoringQueue/monitoringQueueSlice";
import flagDetailsReducer, {
  FLAG_DETAILS_REDUCER_NAME,
} from "./features/flagDetails/flagDetailsSlice";
import singleClientReportReducer, {
  SINGLE_CLIENT_REPORT_REDUCER_NAME,
} from "./features/reports/singleClientReportSlice";
import multipleClientReportReducer, {
  MULTIPLE_CLIENT_REPORT_REDUCER_NAME,
} from "./features/reports/multipleClientReportSlice";
import forMonitoringReducer, {
  FOR_MONITORING_REDUCER_NAME,
} from "./features/reports/forMonitoringSlice";
import dailyForOverlimitReducer, {
  DAILY_FOR_OVERLIMIT_REDUCER_NAME,
} from "./features/reports/dailyForOverlimitSlice";
import auditTrailReducer, {
  AUDIT_TRAIL_REDUCER_NAME,
} from "./features/auditTrail/auditTrailSlice";
import advancedSearchHistoryReducer, {
  ADVANCED_SEARCH_HISTORY_REDUCER_NAME,
} from "./features/advancedSearchHistory/advancedSearchHistorySlice";
import manualSearchReducer, {
  MANUAL_SEARCH_REDUCER_NAME,
} from "./features/manualSearch/manualSearchSlice";
import queryBuilderReducer, {
  QUERY_BUILDER_REDUCER_NAME,
} from "./features/queryBuilder/queryBuilderSlice";
import ruleEditorReducer, {
  RULE_EDITOR_REDUCER_NAME,
} from "./features/ruleEditor/ruleEditorSlice";
import advancedSearchReducer, {
  ADVANCED_SEARCH_REDUCER_NAME,
} from "./features/advancedSearch/advancedSearchSlice";
import savedSearchViewReducer, {
  SAVED_SEARCH_VIEW_REDUCER_NAME,
} from "./features/savedSearchView/savedSearchViewSlice";
import authReducer, {
  AUTH_REDUCER_KEY,
} from "./features/auth/authSlice";
import permissionsReducer, {
  PERMISSIONS_REDUCER_KEY,
} from "./features/permissions/permissionsSlice";

export const store = configureStore({
  reducer: {
    showGroups: showGroupsReducer,
    filters: filtersReducer,
    user: userReducer,
    reportsSelected: reportsSelectedSlice,
    errorFetchingActions: errorFetchingActionsReducer,
    [TREE_VIEW_SELECTED_CHANGE]: treeViewSelectedChangeReducer,
    [FLAG_DETAILS_BACK_ROUTE]: flagDetailsBackButtonReducer,
    [DEFAULT_TABLE_FILTERS]: defaultTableFiltersReducer,
    [SETTINGS_REDUCER_KEY]: settingsReducer,
    [ACTIVITY_LOG_REDUCER_NAME]: activityLogReducer,
    [RULES_PAGE_REDUCER_NAME]: rulesPageReducer,
    [CUSTOM_REPORTS_REDUCER_NAME]: customReportsReducer,
    [MONITORING_QUEUE_REDUCER_NAME]: monitoringQueueReducer,
    [FLAG_DETAILS_REDUCER_NAME]: flagDetailsReducer,
    [SINGLE_CLIENT_REPORT_REDUCER_NAME]: singleClientReportReducer,
    [MULTIPLE_CLIENT_REPORT_REDUCER_NAME]: multipleClientReportReducer,
    [FOR_MONITORING_REDUCER_NAME]: forMonitoringReducer,
    [DAILY_FOR_OVERLIMIT_REDUCER_NAME]: dailyForOverlimitReducer,
    [AUDIT_TRAIL_REDUCER_NAME]: auditTrailReducer,
    [ADVANCED_SEARCH_HISTORY_REDUCER_NAME]: advancedSearchHistoryReducer,
    [MANUAL_SEARCH_REDUCER_NAME]: manualSearchReducer,
    [QUERY_BUILDER_REDUCER_NAME]: queryBuilderReducer,
    [RULE_EDITOR_REDUCER_NAME]: ruleEditorReducer,
    [ADVANCED_SEARCH_REDUCER_NAME]: advancedSearchReducer,
    [SAVED_SEARCH_VIEW_REDUCER_NAME]: savedSearchViewReducer,
    [AUTH_REDUCER_KEY]: authReducer,
    [PERMISSIONS_REDUCER_KEY]: permissionsReducer,
  },
});
